import cc from 'classcat';
import { useRef, useCallback, useEffect } from 'react';
import { BASE_FONT_SIZE } from '@i-ark/constants';
import { HotspotIconPosition } from '@i-ark/models';
import { setAlphaOnColor } from '@i-ark/utils';
import { ReadOutLoudIcon } from '@ui/kit/icons';
import { hotspotIconCls, containerCls } from './Hotspot.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useScale } from '../hooks/useScale.js';
import { ThickLinkIcon } from '../../icons/LinkIcon.thick.js';

const Hotspot = ({
  defaultHotspotColor,
  sheetRef,
  pageId,
  pageAspectRatio,
  zIndex,
  item,
  isSelected,
  isCloned,
  onSelect,
  Hotspot,
  Before,
  After
}) => {
  const scale = useScale();
  const ref = useRef(null);
  const bgColor = item.style.background?.color != null ? setAlphaOnColor(item.style.background.color, item.style.background.opacity ?? 1) : defaultHotspotColor;
  const handleSelect = useCallback(evt => {
    if (onSelect !== undefined) {
      onSelect(evt, item);
    }
  }, [item, onSelect]);
  useEffect(() => {
    const node = ref.current;
    if (node === null) {
      return;
    }
    node.addEventListener("focusin", handleSelect, {
      passive: false
    });
    node.addEventListener("mousedown", handleSelect, {
      passive: false
    });
    node.addEventListener("touchstart", handleSelect, {
      passive: false
    });
    return () => {
      node.removeEventListener("focusin", handleSelect);
      node.removeEventListener("mousedown", handleSelect);
      node.removeEventListener("touchstart", handleSelect);
    };
  }, [item, handleSelect]);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    "data-id": item.id,
    className: cc([containerCls, {
      selected: isSelected
    }]),
    style: {
      zIndex,
      left: `${(item.position.x * 100).toString()}%`,
      top: `${(item.position.y * 100).toString()}%`,
      width: `${(item.size.width * 100).toString()}%`,
      height: `${(item.size.height * 100).toString()}%`,
      backgroundColor: bgColor,
      border: item.style.border !== undefined ? `${Math.max(1, Math.round(item.style.border.width * BASE_FONT_SIZE * scale)).toString()}px ${item.style.border.style} ${item.style.border.color}` : undefined,
      borderRadius: item.style.border?.radius !== undefined ? `${item.style.border.radius.toString()}em` : undefined
    },
    children: [Before !== undefined && /*#__PURE__*/jsx(Before, {
      sheetRef: sheetRef,
      pageId: pageId,
      pageAspectRatio: pageAspectRatio,
      isSelected: isSelected,
      isCloned: isCloned,
      item: item
    }), Hotspot !== undefined && /*#__PURE__*/jsx(Hotspot, {
      sheetRef: sheetRef,
      pageId: pageId,
      pageAspectRatio: pageAspectRatio,
      isSelected: isSelected,
      isCloned: isCloned,
      item: item
    }), item.style.icon.enabled && /*#__PURE__*/jsx("i", {
      ref: ref,
      className: cc([hotspotIconCls, {
        tl: item.style.icon.position === HotspotIconPosition.TOP_LEFT,
        tr: item.style.icon.position === HotspotIconPosition.TOP_RIGHT,
        bl: item.style.icon.position === HotspotIconPosition.BOTTOM_LEFT,
        br: item.style.icon.position === HotspotIconPosition.BOTTOM_RIGHT
      }]),
      children: item.kind === "linkHotspot" ? /*#__PURE__*/jsx(ThickLinkIcon, {
        size: 14
      }) : /*#__PURE__*/jsx(ReadOutLoudIcon, {
        height: 14
      })
    }), After !== undefined && /*#__PURE__*/jsx(After, {
      sheetRef: sheetRef,
      pageId: pageId,
      pageAspectRatio: pageAspectRatio,
      isSelected: isSelected,
      isCloned: isCloned,
      item: item
    })]
  });
};

export { Hotspot };
//# sourceMappingURL=Hotspot.js.map
